import { IGetState, TBoardId, TCustomPropertyId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardUserMetaSetCardPreviewCustomProperties = (
    boardId: TBoardId,
    cardPreviewCustomProperties: TCustomPropertyId[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { cardPreviewCustomProperties }));
    };
    return action;
}
